import React from "react";
import { Layout } from "./ui/Layout";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Button } from "./ui/Button";
import { IconArrowRight14 } from "../icons-ts";
import { Title } from "./ui/Title";
import { Paragraph } from "./ui/Paragraph";
import { LazyLoadImage } from "react-lazy-load-image-component";

const IlluContact = require("../../assets/contact.jpg");

const ImgContact = styled(LazyLoadImage)`
  width: 100%;
  display: block;
`;

const ContactContainer = styled(Row)`
  text-align: center;
`;

export const SectionContact = () => {
  return (
    <>
      <Layout id="contact">
        <ContactContainer around="xs" middle="xs" center="xs">
          <Col xs={false} sm={false} md={5} lg={5}>
            <ImgContact
              src={IlluContact}
              alt="Illustation contact"
              effect="opacity"
              threshold={300}
            />
          </Col>

          <Col xs={12} sm={8} md={5} lg={5}>
            <Title htmlLevel={2} theme="titleBodyStyle">
              Intéressé ou convaincu ?
            </Title>

            <Paragraph style={{ marginBottom: 30 }}>
              Contactez-nous pour plus d’informations ou obtenir une démo
              gratuite de Street Funders.
            </Paragraph>

            <a href="mailto:info@igloo.be">
              <Button icon={<IconArrowRight14 width="14" fill="#FFF" />}>
                Contactez-nous
              </Button>
            </a>
          </Col>
        </ContactContainer>
      </Layout>
    </>
  );
};
